import { render, staticRenderFns } from "./labelItem.vue?vue&type=template&id=4a0cc9b6&scoped=true"
import script from "./labelItem.vue?vue&type=script&lang=js"
export * from "./labelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cc9b6",
  null
  
)

export default component.exports